exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-selected {\n  background: #205c7f;\n  color: #fff;\n  padding: 0.25rem;\n  border-radius: 5px;\n  margin-right: 0.25rem;\n  margin-bottom: 0.25rem;\n  float: left; }\n\n.child {\n  margin-left: 1.5rem; }\n\n.panel-select-option {\n  position: absolute;\n  z-index: 999;\n  background: #fff;\n  padding: 0.75rem 1rem;\n  border-radius: 0px 0px 10px 10px;\n  border: 1px solid #e5e6e7;\n  top: 2rem;\n  width: 90%;\n  height: 11rem;\n  overflow: scroll; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/multidropdown/multidropdown.component.scss
// module id = ../../../../../src/app/share/multidropdown/multidropdown.component.scss
// module chunks = main